var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.3032 53.082C13.0262 53.082 1.44482 41.4557 1.44482 27.1045C1.44482 12.7533 13.0262 1.12695 27.3032 1.12695H27.3349C41.6119 1.12695 53.1933 12.7533 53.1933 27.1045C53.1933 41.4557 41.6119 53.082 27.3349 53.082H27.3032Z","strokeWidth":"2"}));
}

Circle.defaultProps = {"width":"55","height":"55","viewBox":"0 0 55 55"};

module.exports = Circle;

Circle.default = Circle;
